import { PaymentMethod, PaymentType } from "../../../common/payment";

export const getPaymentMethod = <T>(paymentMethods: PaymentMethod[] | null, paymentType: PaymentType) =>
    (paymentMethods?.find((p) => p.paymentType === paymentType) as T | undefined) ?? null;
